import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaConfiguracionPagosColaboradorPagoComponent {
  data
  tipoCambio
  cuentasBancarias
  editable
  eliminable
  onChange
  onDelete
  pagos

  $onChanges (changes) {
    if (changes.tipoCambio) {
      this.actualizarImporteUsd()
    }
  }

  $onInit () {
    this.cuentasBancariasOriginal = this.cuentasBancarias
    this.metodosPago = this.pagos.metodosPago
    this.monedas = this.pagos.monedas

    this.filtrarCuentas()

    this.cuenta_bancaria = this.cuentasBancarias.find((item) => {
      return item.id_moneda === this.data.id_moneda
        && item.id_banco === this.data.banco_id
        && item.cuenta === this.data.banco_cuenta
        && item.clabe === this.data.banco_clabe
        && item.tarjeta === this.data.banco_tarjeta
    })

    this.importeUsd = +(this.data.importe / this.data.tipo_cambio).toFixed(2)
  }

  eliminar () {
    this.onDelete()
  }

  filtrarCuentas () {
    this.cuentasBancarias = this.cuentasBancariasOriginal.filter((item) => item.id_moneda === this.data.id_moneda)
  }

  actualizar () {
    this.onChange()
  }

  actualizarImporte () {
    this.data.importe = +(this.importeUsd * this.data.tipo_cambio).toFixed(2)
    this.actualizar()
  }

  actualizarImporteUsd () {
    this.importeUsd = +(this.data.importe / this.data.tipo_cambio).toFixed(2)
    this.actualizar()
  }

  seleccionarCuenta () {
    if (this.cuenta_bancaria) {
      this.data.banco_id = this.cuenta_bancaria.id_banco
      this.data.banco_cuenta = this.cuenta_bancaria.cuenta
      this.data.banco_clabe = this.cuenta_bancaria.clabe
      this.data.banco_tarjeta = this.cuenta_bancaria.tarjeta
    } else {
      this.data.banco_id = null
      this.data.banco_cuenta = null
      this.data.banco_clabe = null
      this.data.banco_tarjeta = null
    }

    this.actualizar()
  }

  seleccionarMetodo () {
    if (this.data.id_metodo_pago === 1) {
      this.cuenta_bancaria = (this.cuenta_bancaria && this.cuenta_bancaria.id_moneda === this.data.id_moneda)
        ? this.cuenta_bancaria
        : this.cuentasBancarias.find((item) => item.id_moneda === this.data.id_moneda)
    } else {
      this.cuenta_bancaria = undefined
    }

    this.filtrarCuentas()
    this.seleccionarCuenta()
  }

  seleccionarMoneda () {
    this.data.tipo_cambio = this.data.id_moneda === 1 ? 1 : this.tipoCambio

    this.seleccionarMetodo()
  }
}

module.component('nominasNominaConfiguracionPagosColaboradorPago', {
  controller: NominasNominaConfiguracionPagosColaboradorPagoComponent,
  template,
  bindings: {
    data: '<',
    tipoCambio: '<',
    cuentasBancarias: '<',
    editable: '<',
    eliminable: '<',
    onChange: '&',
    onDelete: '&',
  },
  require: {
    pagos: '^nominasNominaConfiguracionPagos',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/configuracion/pagos/colaborador/pago/component.js